<template>
  <div class="body">
      <el-container>
          <el-main>
            <el-row>
                <el-col :xl="{span:10, offset:5}">
            <div class="login">
                     <LoginForm></LoginForm>
                </div>
                  </el-col>
              </el-row>
          </el-main>
      </el-container>
    </div>
</template>

<script>
import LoginForm from '@/components/LoginForm/index.vue'
import 'element-ui/lib/theme-chalk/display.css'
export default {
  components: {
    LoginForm
  },
  name: 'Login',
  data () {
    return {
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
@import "../assets/scss/main.scss";
.body
{
  background:linear-gradient(rgba(16,78,127, .9), rgba(3,168,252, 0.9)), url(../assets/images/main-image.jpg) center top /cover no-repeat;
  min-height: 100vh;
}
h1, h2 {
  font-weight: normal;
}
ul {
  list-style-type: none;
  padding: 0;
  li {
    display: block;
    background: red;
  }
}
/*li {*/
  /*display: inline-block;*/
  /*margin: 0 10px;*/
/*}*/
a {
  color: #42b983;
}
.login-container .login-form
{
    position: absolute;
    left: 0;
    right: 0;
    // width: 520px;
    // padding: 35px 35px 15px 35px;
    // margin: 120px auto;
}
.login {
  position: fixed;
  width: 500px;
  // height: 200px;
  top: 50%;
  left: 50%;
  margin-top: -180px; /* Negative half of height. */
  margin-left: -250px; /* Negative half of width. */
  border-radius: 4px;
  background-color: #ffffff;
  box-shadow: 0 2px 6px 0 rgba(0, 0, 0, 0.06);
}

// @media (max-width: 1219px) {
//   .login {
//     width: 464px;
//     left: 0;
//   }
// }
@media (max-width: 530px) {
  .login {
    width: 400px;
  }
}
@media (max-width: 435px) {
  .login {
    width: 280px;
    margin-left: -140px; /* Negative half of width. */
  }
}
@media (max-width: 375px) {
  .login {
    margin-left: -140px; /* Negative half of width. */
  }
}

@media (max-width: 320px) {
  .login {
    margin-left: -140px; /* Negative half of width. */
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Login.vue